import { resolvePreferredHost, type PreferredHost } from "@spectree/shared";
import { useMe } from "@/hooks/queries/use-me";

/**
 * Resolve the current user's effective CLI host (migration A14/A8b).
 *
 * SpecTree's host-transparent UX requires every onboarding/product surface that
 * renders a command string or host-specific prose to emit it for the user's
 * chosen host (GitHub Copilot CLI vs Claude Code). This hook is the single
 * client-side read path: it reads the persisted `preferredHost` from `/me` and
 * resolves a possibly-null value to an effective host (defaulting to
 * `DEFAULT_PREFERRED_HOST` = copilot) so callers can pass it straight into the
 * host-aware `cli-guidance.ts` builders/accessors and `HOST_GUIDANCE[host]`.
 *
 * Mirrors the pattern already used in `ChatProvider` (`useMe()` +
 * `resolvePreferredHost`), centralized so the wizard steps and product pages
 * don't each re-implement it.
 */
export function useResolvedHost(): PreferredHost {
  const { data: meData } = useMe();
  return resolvePreferredHost(meData?.preferredHost);
}
